const UPDATE_REFERENCES = 'fulcrum/containers/Project/UPDATE_REFERENCES'
const POST_PROJECT = 'fulcrum/containers/Project/POST_PROJECT'
const UPDATE_PROJECT = 'fulcrum/containers/Project/UPDATE_PROJECT'
const UPDATE_PROJECT_SUCCESS = 'fulcrum/containers/Project/UPDATE_PROJECT_SUCCESS'
const LOAD_PROJECT_FORM = 'fulcrum/containers/Project/RESET_ISLOADED'
const SET_ISLOADED = 'fulcrum/containers/Project/SET_ISLOADED'
const RESET_ISLOADED = 'fulcrum/containers/Project/RESET_ISLOADED'
const SET_FORM_STATUS = 'fulcrum/containers/Project/SET_FORM_STATUS'

const GET_PROJECT_DETAILS = 'fulcrum/containers/Project/GET_PROJECT_DETAILS'
const GET_PROJECT_LIST = 'fulcrum/containers/Project/GET_PROJECT_LIST'
const GET_WORKFLOW_DETAILS = 'fulcrum/containers/Project/GET_WORKFLOW_DETAILS'

const POST_UPDATE_PROJECT = 'fulcrum/containers/Project/POST_UPDATE_PROJECT'
const POST_UPDATE_PROJECT_START = 'fulcrum/containers/Project/POST_UPDATE_PROJECT_START'
const POST_UPDATE_PROJECT_SUCCESS = 'fulcrum/containers/Project/POST_UPDATE_PROJECT_SUCCESS'
const POST_UPDATE_PROJECT_ERROR = 'fulcrum/containers/Project/POST_UPDATE_PROJECT_ERROR'

const POST_WORKFLOW_SUBMIT = 'fulcrum/containers/Project/POST_WORKFLOW_SUBMIT'
const POST_WORKFLOW_SUBMIT_START = 'fulcrum/containers/Project/POST_WORKFLOW_SUBMIT_START'
const POST_WORKFLOW_SUBMIT_SUCCESS = 'fulcrum/containers/Project/POST_WORKFLOW_SUBMIT_SUCCESS'
const POST_WORKFLOW_SUBMIT_ERROR = 'fulcrum/containers/Project/POST_WORKFLOW_SUBMIT_ERROR'

const POST_WORKFLOW_RESTART = 'fulcrum/containers/Project/POST_WORKFLOW_RESTART'
const POST_WORKFLOW_RESTART_START = 'fulcrum/containers/Project/POST_WORKFLOW_RESTART_START'
const POST_WORKFLOW_RESTART_SUCCESS = 'fulcrum/containers/Project/POST_WORKFLOW_RESTART_SUCCESS'
const POST_WORKFLOW_RESTART_ERROR = 'fulcrum/containers/Project/POST_WORKFLOW_RESTART_ERROR'

/* Form */
const FETCH_FORM_ELEMENTS = 'fulcrum/containers/Project/FETCH_FORM_ELEMENTS'
const FETCH_FORM_ELEMENTS_START = 'fulcrum/containers/Project/FETCH_FORM_ELEMENTS_START'
const FETCH_FORM_ELEMENTS_SUCCESS = 'fulcrum/containers/Project/FETCH_FORM_ELEMENTS_SUCCESS'
const FETCH_FORM_ELEMENTS_ERROR = 'fulcrum/containers/Project/FETCH_FORM_ELEMENTS_ERROR'

const FETCH_ELEMENT_REFERENCES = 'fulcrum/containers/Project/FETCH_ELEMENT_REFERENCES'
const FETCH_ELEMENT_REFERENCES_START = 'fulcrum/containers/Project/FETCH_ELEMENT_REFERENCES_START'
const FETCH_ELEMENT_REFERENCES_SUCCESS = 'fulcrum/containers/Project/FETCH_ELEMENT_REFERENCES_SUCCESS'
const FETCH_ELEMENT_REFERENCES_ERROR = 'fulcrum/containers/Project/FETCH_ELEMENT_REFERENCES_ERROR'

const LOAD_PROJECT_FORM_DATA = 'fulcrum/containers/Project/LOAD_PROJECT_FORM_DATA'
const LOAD_PROJECT_FORM_DATA_START = 'fulcrum/containers/Project/LOAD_PROJECT_FORM_DATA_START'
const LOAD_PROJECT_FORM_DATA_SUCCESS = 'fulcrum/containers/Project/LOAD_PROJECT_FORM_DATA_SUCCESS'

const FORM_STATUS = {
  CLONE: 'CLONE',
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  REVIEW: 'REVIEW',
  VIEW: 'VIEW',
}
Object.freeze(FORM_STATUS)

export {
  POST_PROJECT,
  UPDATE_PROJECT,
  GET_PROJECT_DETAILS,
  GET_PROJECT_LIST,
  GET_WORKFLOW_DETAILS,
  POST_UPDATE_PROJECT,
  POST_UPDATE_PROJECT_START,
  POST_UPDATE_PROJECT_SUCCESS,
  POST_UPDATE_PROJECT_ERROR,
  LOAD_PROJECT_FORM,
  SET_ISLOADED,
  RESET_ISLOADED,
  SET_FORM_STATUS,
  FORM_STATUS,
  POST_WORKFLOW_SUBMIT,
  POST_WORKFLOW_SUBMIT_START,
  POST_WORKFLOW_SUBMIT_SUCCESS,
  POST_WORKFLOW_SUBMIT_ERROR,
  POST_WORKFLOW_RESTART,
  POST_WORKFLOW_RESTART_START,
  POST_WORKFLOW_RESTART_SUCCESS,
  POST_WORKFLOW_RESTART_ERROR,
  /* Form */
  FETCH_FORM_ELEMENTS,
  FETCH_FORM_ELEMENTS_START,
  FETCH_FORM_ELEMENTS_SUCCESS,
  FETCH_FORM_ELEMENTS_ERROR,
  FETCH_ELEMENT_REFERENCES,
  FETCH_ELEMENT_REFERENCES_START,
  FETCH_ELEMENT_REFERENCES_SUCCESS,
  FETCH_ELEMENT_REFERENCES_ERROR,
  LOAD_PROJECT_FORM_DATA,
  UPDATE_REFERENCES,
  UPDATE_PROJECT_SUCCESS,
  LOAD_PROJECT_FORM_DATA_START,
  LOAD_PROJECT_FORM_DATA_SUCCESS,
}
